<template>
    <div>
        <!-- <BackButton /> -->
        <div class="checkinout-header">
            <img class="checkinout-logo" src="/assets/layout/images/logo.svg" alt="ProAstra">
            <h1>
                <span>Thank you!</span>
                You have checked {{ this.$route.params.checked }}.
            </h1>

        </div>
        <div class="checkinout-details" v-if="this.$route.params.checked == 'in'">
            <div class="checkout-detailsform" v-if="this.$route.query.is_asset_page == 1">
                <Button type="button" @click.prevent="$router.back()" label="Go to Asset Details" class="checkinout-submit" />
                <Button type="button" @click.prevent="$router.push('/scan')" v-if="this.$route.params.checked == 'in'" label="Tap NFC/Scan QR Code" style="margin-top: 1rem;" class="checkinout-submit" />
            </div>
            <div class="checkout-detailsform" v-else>
                <Button type="button" @click.prevent="$router.push('/scan')" v-if="this.$route.params.checked == 'in'" label="Tap NFC/Scan QR Code" class="checkinout-submit" />
                <Button type="button" @click.prevent="$router.back()" label="Check Out" class="checkinout-submit" style="margin-top: 1rem;" />
            </div>
        </div>
        <Toast />
    </div>
</template>

<script>
import BackButton from '../components/BackButton.vue';

export default {
    data() {
        return {}
    },
    props: ['isOnline'],
    components: {
        BackButton
    },
    created() {
        // sets/removes cookies
        if (this.$route.params.checked == 'in') {
            this.$cookie.set('ProAstra_checkedIn', 1, { expires: '12h' });
            this.$cookie.set('ProAstra_checkInName', this.$route.params.full_name, { expires: '12h' });
            this.$cookie.set('ProAstra_checkInCompany', this.$route.params.company, { expires: '12h' });
        } else {
            this.$cookie.delete('ProAstra_checkedIn');
            this.$cookie.delete('ProAstra_checkInName');
            this.$cookie.delete('ProAstra_checkInCompany');
        }
        console.log(window.history)
    }
}
</script>

<style scoped lang="scss"></style>
